import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktdefinitionViewModel } from "../models/ProduktdefinitionViewModel";

export class ProduktinstruktionerValidation {
    // eslint-disable-next-line sonarjs/public-static-readonly
    static negativtVarde = "Värde får inte vara negativt";
    // eslint-disable-next-line sonarjs/duplicates-in-character-class, sonarjs/public-static-readonly
    static namnRegex = /[^a-z|\u00C5|\u00C4|\u00D60-9-+,() ]/i;

    static init(produktinstruktionViewModel: ProduktdefinitionViewModel): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Namn krävs och får endas innehålla tecknen a till ö 0 till 9 och +-()" },
                model: () => produktinstruktionViewModel.headerData.namn,
                name: "namn",
                verbose: true,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0 || ProduktinstruktionerValidation.namnRegex.test(newValue))
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0),
                message: { text: "Trädslagsgrupp krävs" },
                model: () => produktinstruktionViewModel.headerData.tradslagsgrupp,
                name: "tradslagsgrupp",
                verbose: true,
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0),
                message: { text: "Produktgrupp krävs" },
                model: () => produktinstruktionViewModel.headerData.produktgrupp,
                name: "produktgrupp",
                verbose: true,
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                applicable: (newValue) => !!newValue && produktinstruktionViewModel.headerData.pinEnbartForSimulering === false,
                expression: (newValue) => newValue.length === 4 || newValue.length === 5,
                message: { text: "Sortimentskod måste vara 4 eller 5 tecken" },
                model: () => produktinstruktionViewModel.headerData.sortiment,
                verbose: true,
                name: "sortimentskod"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Version måste anges" },
                model: () => produktinstruktionViewModel.headerData.version,
                verbose: true,
                name: "version",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Max längd måste anges" },
                model: () => produktinstruktionViewModel.headerData.maxlangd,
                verbose: true,
                name: "maxlangd",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: this.negativtVarde },
                model: () => produktinstruktionViewModel.headerData.maxlangd,
                verbose: true,
                name: "maxlangd",
                expression: (newValue) => newValue >= 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Max toppdiameter" },
                model: () => produktinstruktionViewModel.headerData.maxdiameter,
                verbose: true,
                name: "maxdiameter",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: this.negativtVarde },
                model: () => produktinstruktionViewModel.headerData.maxdiameter,
                verbose: true,
                name: "maxdiameter",
                expression: (newValue) => newValue >= 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Pristyp måste väljas" },
                model: () => produktinstruktionViewModel.grunddata.pristyp,
                verbose: true,
                name: "pristyp",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Volymtyp måste väljas" },
                model: () => produktinstruktionViewModel.grunddata.volymlangdKategori,
                verbose: true,
                name: "volymtyp",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Apteringsvilkor måste väljas" },
                model: () => produktinstruktionViewModel.grunddata.apteringsvillkor,
                verbose: true,
                name: "apteringsvillkor",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: this.negativtVarde },
                model: () => produktinstruktionViewModel.grunddata.kvalitetToleransTopp,
                verbose: true,
                name: "kvalitetToleransTopp",
                expression: (newValue) => newValue >= 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: this.negativtVarde },
                model: () => produktinstruktionViewModel.grunddata.kvalitetToleransRot,
                verbose: true,
                name: "kvalitetToleransRot",
                expression: (newValue) => newValue >= 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Om värde angivet får inte värdet vara negativt" },
                model: () => produktinstruktionViewModel.grunddata.minstaToppdiameter,
                verbose: true,
                name: "minstaToppdiameter",
                expression: (newValue) => ObjectUtils.isNullOrUndefined(newValue) || newValue >= 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Om värde angivet måste värdet vara större än 0" },
                model: () => produktinstruktionViewModel.grunddata.maxRotdiameter,
                verbose: true,
                name: "maxRotdiameter",
                expression: (newValue) => ObjectUtils.isNullOrUndefined(newValue) || newValue > 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Både övre och nedre kapgräns måste anges" },
                model: () => produktinstruktionViewModel.grunddata.kapfonsterOvreGrans,
                verbose: true,
                name: "kapfonsterOvreGrans",
                subscriptions: ["kapfonsterNedreGrans"],
                publish: true,
                expression: (newValue) => ObjectUtils.isNullOrUndefined(newValue) && ObjectUtils.isNullOrUndefined(produktinstruktionViewModel.grunddata.kapfonsterNedreGrans) ||
                    !ObjectUtils.isNullOrUndefined(newValue) && !ObjectUtils.isNullOrUndefined(produktinstruktionViewModel.grunddata.kapfonsterNedreGrans)
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Både övre och nedre kapgräns måste anges" },
                model: () => produktinstruktionViewModel.grunddata.kapfonsterNedreGrans,
                verbose: true,
                name: "kapfonsterNedreGrans",
                subscriptions: ["kapfonsterOvreGrans"],
                publish: true,
                expression: (newValue) => ObjectUtils.isNullOrUndefined(newValue) && ObjectUtils.isNullOrUndefined(produktinstruktionViewModel.grunddata.kapfonsterOvreGrans) ||
                    !ObjectUtils.isNullOrUndefined(newValue) && !ObjectUtils.isNullOrUndefined(produktinstruktionViewModel.grunddata.kapfonsterOvreGrans)
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: this.negativtVarde },
                model: () => produktinstruktionViewModel.stolpdata.matpunktOverStubbe,
                verbose: true,
                name: "matpunktOverStubbe",
                expression: (newValue) => newValue >= 0
            }
        ]);

        return context;
    }
}
